export default __webpack_public_path__ + "static/media/mastercard.c27623c5.svg";